// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-18ccbf99] .ant-form-item {\n  display: flex;\n}\n[data-v-18ccbf99] .ant-form-item .ant-form-item-control-wrapper,[data-v-18ccbf99] .ant-form-item .ant-select {\n  flex: 1;\n  overflow: hidden;\n}", ""]);
// Exports
module.exports = exports;
